export enum LOCALE {
  EN_US = "en-us",
  ZH_CN = "zh-cn",
  ZH_HK = "zh-hk",
}
